import lodash from 'lodash'
import React, { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import OrderDetail from '../../../components/OrderDetail'
import { cancelColi, requestOrder } from '../actions'
import { makeSelectIsLoading, makeSelectOrder, selectError } from '../selectors'

const connectRedux = connect(
  createStructuredSelector({
    item: makeSelectOrder(),
    isLoading: makeSelectIsLoading(),
    error: selectError,
  }),
  { cancelColi, requestOrder },
)

const Detail = (props) => {
  // const {} = props
  // console.log('props', props)
  /*
cancelColi: ƒ ()
error: undefined
history: {length: 3, action: 'PUSH', location: {…}, createHref: ƒ, push: ƒ, …}
isLoading: false
item: {id: 1862, customerRef1: '', customerRef2: '', customerRef3: '', customerName1: 'update testgfaf', …}
location: {pathname: '/order/1862', search: '', hash: '', state: undefined, key: 'jbwtdt'}
match: {path: '/order/:id', url: '/order/1862', isExact: true, params: {…}}
requestOrder: ƒ ()
saveValues: ƒ ()
staticContext: undefined
  */
  return <OrderDetail hideSimiliarOrder={false} {...props} />
}

export default connectRedux(Detail)
